(function () {

  var upcomingProductIds = [
    8497827971264
  ];

  var upcomingIds = upcomingProductIds.map(String);

  function applyFixes() {
    upcomingIds.forEach(function (productId) {

      // ── Badges ──────────────────────────────────────────────────────
      // Targets both Badge-* and NoMediaStandardBadge-* ids ending with the product ID
      document.querySelectorAll('[id$="-' + productId + '"]').forEach(function (el) {
        if (el.classList.contains('badge') && el.textContent.trim() === 'Sold out') {
          el.textContent = 'Upcoming';
        }
      });

      // ── Quick Add Buttons ───────────────────────────────────────────
      // Targets button ids ending with the product ID
      document.querySelectorAll('button[id$="' + productId + '-submit"]').forEach(function (btn) {
        if (btn.disabled) {
          // Case 1: direct text node (multi-variant modal button)
          btn.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Sold out') {
              node.textContent = ' Upcoming ';
            }
          });

          // Case 2: <span> inside button (single-variant form button)
          btn.querySelectorAll('span').forEach(function (span) {
            if (!span.classList.contains('sold-out-message') &&
                !span.classList.contains('hidden') &&
                span.textContent.trim() === 'Sold out') {
              span.textContent = 'Upcoming';
            }
          });
        }
      });

    });

    // ── Product Page ──────────────────────────────────────────────────
    if (document.body.classList.contains('template-product')) {
      var currentProductId = window.ShopifyAnalytics &&
                             window.ShopifyAnalytics.meta &&
                             window.ShopifyAnalytics.meta.product &&
                             String(window.ShopifyAnalytics.meta.product.id);

      if (currentProductId && upcomingIds.includes(currentProductId)) {
        document.querySelectorAll('.price__badge-sold-out').forEach(function (badge) {
          if (badge.textContent.trim() === 'Sold out') badge.textContent = 'Upcoming';
        });
        document.querySelectorAll('.product-form__submit').forEach(function (btn) {
          if (btn.disabled) {
            var span = btn.querySelector('span:not(.hidden)');
            if (span && span.textContent.trim() === 'Sold out') span.textContent = 'Upcoming';
          }
        });
      }
    }
  }

  // Fire at every possible timing
  applyFixes();
  document.addEventListener('DOMContentLoaded', applyFixes);
  window.addEventListener('load', applyFixes);
  setTimeout(applyFixes, 300);
  setTimeout(applyFixes, 800);
  setTimeout(applyFixes, 1500);

  // MutationObserver — catches any Shopify re-renders
  document.addEventListener('DOMContentLoaded', function () {
    var debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(applyFixes, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  });

})();